import React, { useState, useEffect, useContext } from 'react';
import { Navbar, Nav, Container, Dropdown } from 'react-bootstrap';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import AppContext from '../../context/AppContext';
import '../../assets/css/general/MyNavbar.css';

const MyNavbar = () => {
  const [mnb_scrolled, setMnbScrolled] = useState(false);
  const { loggedInCustomer, setLoggedInCustomer } = useContext(AppContext);
  const navigate = useNavigate();

  useEffect(() => {
    const mnb_handleScroll = () => {
      setMnbScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', mnb_handleScroll);
    return () => window.removeEventListener('scroll', mnb_handleScroll);
  }, []);

  useEffect(() => {
    // Agar context empty ho (page refresh ke baad) to localStorage se le lo
    if (!loggedInCustomer) {
      const storedCustomer = localStorage.getItem('loggedInCustomer');
      if (storedCustomer) {
        setLoggedInCustomer(JSON.parse(storedCustomer));
      }
    }
  }, [loggedInCustomer, setLoggedInCustomer]);

  const mnb_handleLogout = () => {
    localStorage.removeItem('customerEmail');
    localStorage.removeItem('customerPassword');
    localStorage.removeItem('loggedInCustomer');
    setLoggedInCustomer(null);
    navigate('/customer/login');
  };

  return (
    <Navbar
      expand="lg"
      fixed="top"
      className={`mnb-navbar ${mnb_scrolled ? 'mnb-scrolled' : ''}`}
    >
      <Container>

        {/* ── Logo ── */}
        <Navbar.Brand as={Link} to="/" className="mnb-brand">
          <div className="mnb-logo-wrap">
            <div className="mnb-logo-icon">
              <span className="mnb-logo-letter">B</span>
            </div>
            <span className="mnb-brand-text">Bridely</span>
          </div>
        </Navbar.Brand>

        {/* ── Mobile Toggle ── */}
        <Navbar.Toggle aria-controls="mnb-nav" className="mnb-toggler">
          <span className="mnb-toggler-icon" />
        </Navbar.Toggle>

        <Navbar.Collapse id="mnb-nav">
          {/* ── Nav Links ── */}
          <Nav className="mx-auto">
            {[
              { label: 'Home',     to: '/'         },
              { label: 'Events',    to: '/events'     },
              // { label: 'Services', to: '/services'  },
              { label: 'Venues',   to: '/venues'    },
              { label: 'Packages',   to: '/packages'    },
              { label: 'About', to: '/about'  },
              { label: 'Blogs',     to: '/blogs'    },
            ].map(item => (
              <Nav.Link
                key={item.to}
                as={NavLink}
                to={item.to}
                end={item.to === '/'}
                className="mnb-link"
              >
                {item.label}
              </Nav.Link>
            ))}
          </Nav>

          {/* ── Right Actions ── */}
          <div className="mnb-actions">
            {/* Contact Button */}
            <Link to="/contact" className="mnb-btn-contact">
              Contact
            </Link>

            {/* Login Button OR Customer Name */}
            {loggedInCustomer ? (
              <Dropdown align="end">
                <Dropdown.Toggle as="div" className="mnb-btn-customer">
                  {loggedInCustomer.firstName || 'Account'}
                </Dropdown.Toggle>

                <Dropdown.Menu className="mnb-customer-menu">
                  <Dropdown.Item as={Link} to="/customer/dashboard">
                    Dashboard
                  </Dropdown.Item>
                  <Dropdown.Item onClick={mnb_handleLogout}>
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <Link to="/customer/login" className="mnb-btn-login">
                Login
              </Link>
            )}
          </div>
        </Navbar.Collapse>

      </Container>
    </Navbar>
  );
};

export default MyNavbar;